import { render, staticRenderFns } from "./BalanceDetails.vue?vue&type=template&id=cd4f973a&"
import script from "./BalanceDetails.vue?vue&type=script&lang=js&"
export * from "./BalanceDetails.vue?vue&type=script&lang=js&"
import style0 from "./BalanceDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports